import http from '../http/http';

import {
    generateEndpoint,
    OFFICER_ROLES,
    OFFICERS,
    UPDATE_OFFICER,
    OFFICERS_BY_SERVICE_PROVIDER,
} from '../http/endpoints';

export default (() => {
    const getAll = () => http.get(generateEndpoint(OFFICERS));

    const update = (id, params) =>
        http.put(generateEndpoint(UPDATE_OFFICER, { id }), params);

    const getAllRoles = () => http.get(generateEndpoint(OFFICER_ROLES));

    const getAllByServiceProvider = (id) =>
        http.get(generateEndpoint(OFFICERS_BY_SERVICE_PROVIDER, { id }));

    return {
        update,
        getAll,
        getAllRoles,
        getAllByServiceProvider,
    };
})();
